import Carregando from '@/shared/components/Carregando';
import { Fragment, useEffect, useState } from 'react';
import { GetRelatorioNucleo } from '@/modules/reports/relatorio.service';
import { RelatorioNucleoDto } from '@/api.types';
import {
  filtrarNucleosComEstagiarios,
  tituloVigenciaLotacao,
} from '../reports/relatorio-nucleo.utils';
import { toast } from 'react-toastify';

export default function RelatorioEstagiariosNucleos() {
  const [loading, setLoading] = useState(true);
  const [nucleos, setNucleos] = useState<RelatorioNucleoDto[]>([]);

  useEffect(() => {
    GetRelatorioNucleo()
      .then((result) => {
        setNucleos(filtrarNucleosComEstagiarios(result));
      })
      .catch((err) => toast.error((err as string) || 'Erro ao buscar núcleos'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Carregando />;
  return (
    <div className="col-12" id="conteudo">
      <h4 className="text-center relatorio-font relatorio-titulo">
        ESTAGIÁRIOS POR NÚCLEO
      </h4>
      <br />
      <div className="table-responsive">
        <table className="table table-sm table-bordered align-middle mt-3 relatorio-font border border-dark fw-bold">
          <thead>
            <tr className="text-center fs-5">
              <th>NÚCLEOS</th>
              <th>ESTAGIÁRIOS</th>
            </tr>
          </thead>
          <tbody>
            {nucleos.map((nucleo, index) => (
              <Fragment key={index}>
                <tr>
                  <td className="text-center fs-6">
                    {nucleo.nome}
                    <br />
                    <br />({nucleo.lotacoes?.length} estagiários)
                  </td>
                  <td>
                    <ul>
                      {nucleo.lotacoes?.map((lotacao, idx) => {
                        const estagiario = lotacao.estagio?.estagiario;
                        const nomeEstagiario = (estagiario as any)?.nome || estagiario?.pessoa?.nome || '';
                        return (
                          <li
                            key={idx}
                            className={lotacao.ativo ? '' : 'text-decoration-line-through'}
                            title={tituloVigenciaLotacao(lotacao)}
                          >
                            {nomeEstagiario} {lotacao.anotacao1 ? '-' : ''} {lotacao.anotacao1 || ''} {lotacao.anotacao2 || ''}
                          </li>
                        );
                      })}
                    </ul>
                  </td>
                </tr>
              </Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
